import { Pipe, PipeTransform } from '@angular/core';

//
//  Usage example:
//  <span [innerHtml]="title | nlOnWords: 'order?'"></span>
//

@Pipe({ name: 'nlOnWords' })
export class NlOnWordsPipe implements PipeTransform {
    transform(value: string, ...words: string[]): string {
        if (typeof value !== 'string' || !words || words.length === 0) return value;

        return words.reduce((acc, word) => acc.replace(word, `<br />${word}`), value);
    }
}
